import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Instantly snaps the main browser window back to coordinates (0,0)
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]); // Fires every single time the URL path changes

  return null; // This component doesn't render any UI
}